// extracted by mini-css-extract-plugin
export default {"footerBar":"styles_footerBar__rdgm7"};